module.exports = __webpack_public_path__ + "img/tooltip_04-vallone-wood-rovere-termo-trattato.c63ceef8.jpg";